import { useLanguage } from '../i18n/LanguageContext';
import React, { useState } from "react";

import "./LoginPage.css";
import logoImage from "../assets/logo.png";
import iconImage from "../assets/icon.png";

import { signIn } from "../api/auth";
import { hashPassword } from "../utils/crypto";
import { saveAuth } from "../utils/auth";

function LoginPage({ onLogin }) {
  const { t } = useLanguage();
  const [username, setUsername] = useState("csadmin");
  const [password, setPassword] = useState("admin1234");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (isLoading) return;

    setError("");
    setIsLoading(true);

    console.log(`we'll trying login`);

    try {
      // 백엔드는 SHA-256 해시값을 기대하므로 평문을 해싱한 뒤 전송
      const hashed = await hashPassword(password);
      const data = await signIn({ username, password: hashed });

      // 프론트엔드 스크린: 백엔드가 통과시켜도 한 번 더 role 확인
      const role_admin = ['Admin', 'Manager', 'SiteManager'];

      console.log(`isAdmin: ${role_admin.includes(data?.user?.role)} : [${data?.user?.role}]`);

      if (!role_admin.includes(data?.user?.role)) {
        setError("관리자 권한이 없습니다.");
        return;
      }

      // 인증 정보 저장 후 부모 컴포넌트로 로그인 성공 알림
      saveAuth(data.access_token, data.user);

      onLogin();
    } catch (err) {
      console.log(`err: ${err}`);
      const msg =
        err?.response?.data?.message ||
        "아이디 또는 비밀번호가 올바르지 않습니다.";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <img src={logoImage} alt="SquareGolf Logo" className="login-top-logo" />

      <div className="login-header">
        <h1 className="login-title">SquareGolf</h1>
        <p className="login-subtitle">{t("고객지원 통합 관리 시스템")}</p>
      </div>

      <div className="login-box">
        <form onSubmit={handleLogin}>
          <div className="login-form-group">
            <label className="login-label">Username</label>
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
            />
          </div>
          <div className="login-form-group">
            <label className="login-label">Password</label>
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={() => {
                if (error) {
                  setPassword(""); // 에러가 있을 때 포커스하면 비번 초기화
                }
              }}
              required
            />
          </div>
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading && <span className="login-spinner"></span>}
            {isLoading ? t("로그인 중...") : t("로그인")}
          </button>
        </form>

        {error && <div className="login-error">{error}</div>}
      </div>

      <div className="login-footer">
        <img src={iconImage} alt="Invant Icon" className="login-footer-icon" />
        <span>Invant Inc.</span>
      </div>
    </div>
  );
}

export default LoginPage;
